import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {
    getAccountConfiguration: `${baseURL}/api/account/configuration`,
    getAccountCustomSettings: `${baseURL}/api/account/customsettings`,
    getAccountStatus: `${baseURL}/api/account/status`,
    getUserById: (idUser) =>
      `${baseURL}/api/user/${encodeURIComponent(idUser)}`,
    getOptionByShortName: (shortName) =>
      `${baseURL}/api/option/${encodeURIComponent(shortName)}`,
    getOptions: `${baseURL}/api/options`
  }
})(process.env.BEACCOUNTS_URL)

export const beAccountsApiGetAccountConfiguration = () => {
  const url = endpoints.getAccountConfiguration
  //
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beAccountsApiGetAccountCustomSettings = () => {
  const url = endpoints.getAccountCustomSettings

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beAccountsApiGetAccountStatus = () => {
  const url = endpoints.getAccountStatus

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beAccountsApiGetUserById = (idUser = 0) => {
  const url = endpoints.getUserById(idUser)

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beAccountsApiGetOptionByShortName = (shortName) => {
  const url = endpoints.getOptionByShortName(shortName)

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beAccountsApiGetOptions = (options) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getOptions,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ ShortNames: options })
  }).then(({ data }) => data)
}
